const constants = {
  CONTROLLER_HEIGHT: '48px',
  DROPDOWN_OFFSET: '80px',
  // The hight of listbox 6 loading items
  SEARCHABLE_LISTBOX_HEIGHT: '312px',
};

export default constants;
